import DashboardComponent from "components/admin/Dashboard";

const DashboardPage = () => {
  return (
    <div style={{flex: 'auto', height: '100vh', overflow: 'scroll'}} className="">
      <DashboardComponent />
    </div>
  );
};

export default DashboardPage;
